<template lang="pug">
  .modal-wrapper
    .modal-wrapper__mask(
      @mousedown="closeModal($event)"
    )
      .modal-wrapper__modal(
        @mousedown.stop
      )
        sign-in(
        v-if="mode === 'sign-in'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        sign-up(
        v-if="mode === 'sign-up'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        change-password(
        v-if="mode === 'change-password'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        reset-password(
        v-if="mode === 'reset-password'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        notification(
        v-if="mode === 'notification'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        notification-event(
        v-if="mode === 'notification-event'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        ordering(
        v-if="mode === 'ordering'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        operator-approve(
          v-if="mode === 'operator-approve'"
          @close="closeModal"
          :modalData="currentModalData"
          @changeModalMode="changeModalMode"
        )
        operator-rejection(
        v-if="mode === 'operator-rejection'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        operator-modal-info(
        v-if="mode === 'operator-modal-info'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        awards(
        v-if="mode === 'awards'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        awards-read-only(
        v-if="mode === 'awards-read-only'"
        @close="closeModal"
        :modalData="currentModalData"
        )
        add-portfolio(
        v-if="mode === 'add-portfolio'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        check-profile(
        v-if="mode === 'check-profile'"
        @close="closeModal"
        @changeModalMode="changeModalMode"
        )
        user-order(
        v-if="mode === 'user-order'"
        @close="closeModal"
        :modalData="currentModalData"
        @changeModalMode="changeModalMode"
        )
        confirm-reserve(
        v-if="mode === 'confirm-reserve'"
        @close="closeModal"
        :modalData="modalData"
        @changeModalMode="changeModalMode"
        )
</template>
<script>
import SignIn from "./components/sign-in";
import SignUp from "./components/sign-up";
import ChangePassword from "./components/change-password";
import Notification from "./components/notification";
import NotificationEvent from "./components/notification-event";
import Ordering from "./components/ordering";
import OperatorRejection from "./components/operator-rejection.vue";
import OperatorApprove from "./components/operator-approve.vue";
import Awards from "./components/awards.vue";
import AwardsReadOnly from "./components/awards-read-only.vue";
import OperatorModalInfo from "./components/operator-modal-info.vue";
import AddPortfolio from "./components/add-portfolio.vue";
import CheckProfile from "./components/check-profile.vue";
import UserOrder from "./components/user-order.vue";
import ConfirmReserve from "./components/confirm-reserve";
import ResetPassword from "./components/reset-password";
export default {
  name: "modal",
  components: {
    ResetPassword,
    ConfirmReserve,
    UserOrder,
    CheckProfile,
    AddPortfolio,
    OperatorModalInfo,
    OperatorApprove,
    OperatorRejection,
    Ordering,
    Notification,
    ChangePassword,
    SignUp,
    SignIn,
    NotificationEvent,
    Awards,
    AwardsReadOnly,
  },
  props: {
    mode: {
      type: String,
      default: "",
    },
    modalData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentModalData: this.modalData,
    };
  },
  /*computed: {
    currentModalData: {
      get() {
        return this.modalData
      },
      set() {}
    }
  },*/
  methods: {
    closeModal() {
      if (this.mode === "change-password") {
        this.$router.replace({ query: {} });
      }
      this.$emit("close");
    },
    changeModalMode(mode, data) {
      if (mode === "notification" || (mode === "ordering" && data)) {
        this.currentModalData = data;
      }
      this.$emit("changeModalMode", mode);
    },
  },
};
</script>
